import React, { Component } from 'react';
import { List, WhiteSpace, Modal, Toast } from 'antd-mobile';
import F2 from '@antv/f2/lib/index';
import df from 'dateformat';
import { ROOT_PATH } from '../../config';
import axios from 'axios';
import { FARM_ORG, ORG_CODE, TOKEN } from '../../cache';
import qs from 'qs';
import Table from '../../components/Table';
import Farrow19WkDetail from './farrow19WkDetail';
import EmptyReport from '../../components/EmptyReport';
import DatePicker from '../../components/DatePicker';
import { dateToWeek } from '../../utils/weekToDate';
import Farrow19WkDetail2 from './farrow19WkDetail2';
import Gesture from '@antv/f2/lib/plugin/gesture';

F2.Chart.plugins.register(Gesture);

let Util = F2.Util;
let stateToColor = {
  返情: '#FDB35E',
  流产: '#FE6678',
  空怀: '#31C0B0',
  死亡: '#897DEC',
  淘汰: '#FFD400',
  配种数: '#1890FF',
  实际分娩率: '#FE5578',
  预计分娩率: '#27D3A6'
};

const today = new Date();
let clientWidth = document.documentElement.clientWidth;
let alreay = 0;

class Farrow19WK extends Component {
  constructor(props) {
    super(props);

    var farrowChart = null;
    var lossChart = null;

    let beginDate = new Date(today.valueOf() - 18 * 7 * 24 * 60 * 60 * 1000);

    this.state = {
      modalShow: false,
      modalHeader: '',
      modalContent: null,
      date: today,
      startWeek: dateToWeek(beginDate),
      endWeek: dateToWeek(today),
      startDate: beginDate,
      endDate: today,
      hasFarrowData: true,
      hasLossData: true,
      tableData: [],
      columns: [
        { id: 'mateGroup', title: '', fixed: true, width: 50, align: 'left' },
        {
          id: 'qtymate',
          title: '配种数',
          align: 'right',
          render: (data, index, item) => {
            if (data.mateGroup === '合计') {
              return <span>{data.qtymate}</span>;
            }
            return (
              <span
                style={{ color: '#108EE9' }}
                onClick={() => {
                  let obj = {};
                  obj['startWeek'] = data.mateGroup;
                  obj['type'] = 'qtymate';
                  this.setState({
                    modalShow: true,
                    modalContent: <Farrow19WkDetail data={obj} />
                  });
                }}
              >
                {data.qtymate}
              </span>
            );
          }
        },
        {
          id: 'rebreed',
          title: '返情',
          align: 'right',
          render: (data, index, item) => {
            if (data.mateGroup === '合计') {
              return <span>{data.rebreed}</span>;
            }
            return (
              <span
                style={{ color: '#108EE9' }}
                onClick={() => {
                  let obj = {};
                  obj['startWeek'] = data.mateGroup;
                  obj['type'] = 'rebreed';
                  this.setState({
                    modalShow: true,
                    modalContent: <Farrow19WkDetail data={obj} />
                  });
                }}
              >
                {data.rebreed}
              </span>
            );
          }
        },
        {
          id: 'abortion',
          title: '流产',
          align: 'right',
          render: (data, index, item) => {
            if (data.mateGroup === '合计') {
              return <span>{data.abortion}</span>;
            }
            return (
              <span
                style={{ color: '#108EE9' }}
                onClick={() => {
                  let obj = {};
                  obj['startWeek'] = data.mateGroup;
                  obj['type'] = 'abortion';
                  this.setState({
                    modalShow: true,
                    modalContent: <Farrow19WkDetail data={obj} />
                  });
                }}
              >
                {data.abortion}
              </span>
            );
          }
        },
        {
          id: 'empty',
          title: '空怀',
          align: 'right',
          render: (data, index, item) => {
            if (data.mateGroup === '合计') {
              return <span>{data.empty}</span>;
            }
            return (
              <span
                style={{ color: '#108EE9' }}
                onClick={() => {
                  let obj = {};
                  obj['startWeek'] = data.mateGroup;
                  obj['type'] = 'empty';
                  this.setState({
                    modalShow: true,
                    modalContent: <Farrow19WkDetail data={obj} />
                  });
                }}
              >
                {data.empty}
              </span>
            );
          }
        },
        {
          id: 'dead',
          title: '死亡',
          align: 'right',
          render: (data, index, item) => {
            if (data.mateGroup === '合计') {
              return <span>{data.dead}</span>;
            }
            return (
              <span
                style={{ color: '#108EE9' }}
                onClick={() => {
                  let obj = {};
                  obj['startWeek'] = data.mateGroup;
                  obj['type'] = 'dead';
                  this.setState({
                    modalShow: true,
                    modalContent: <Farrow19WkDetail data={obj} />
                  });
                }}
              >
                {data.dead}
              </span>
            );
          }
        },
        {
          id: 'cull',
          title: '淘汰',
          align: 'right',
          render: (data, index, item) => {
            if (data.mateGroup === '合计') {
              return <span>{data.cull}</span>;
            }
            return (
              <span
                style={{ color: '#108EE9' }}
                onClick={() => {
                  let obj = {};
                  obj['startWeek'] = data.mateGroup;
                  obj['type'] = 'cull';
                  this.setState({
                    modalShow: true,
                    modalContent: <Farrow19WkDetail data={obj} />
                  });
                }}
              >
                {data.cull}
              </span>
            );
          }
        },
        { id: 'farrowingFcstRate', title: '预计分娩率', align: 'right' },
        { id: 'farrowingRate', title: '实际分娩率', align: 'right' }
      ]
    };
  }

  // 获取 19周分娩率
  getFarrow19WeekData = (startWeek, endWeek) => {
    axios
      .post(
        `${ROOT_PATH}/api/forward/ifarm/Farrow19WkGraph`,
        qs.stringify(
          {
            mateGroupStart: startWeek,
            mateGroupEnd: endWeek,
            gd_type: 'D001301',
            gd_code: ['2001.01', '2001.02']
          },
          {
            indices: false
          }
        ),
        {
          headers: {
            'x-http-appid': '1',
            'x-http-device': '0',
            'Content-Type': 'application/x-www-form-urlencoded',
            Authorization: TOKEN,
            farmorg: FARM_ORG,
            orgcode: ORG_CODE
          }
        }
      )
      .then((res) => {
        alreay++;
        this.parseFarrow19WkData(res.data);
        this.getTableData(res.data);
      })
      .catch((err) => {
        this.setState({ hasFarrowData: false });
        return err;
      });
  };

  // 获取19周分娩率表格
  getTableData(dataSource) {
    if (!dataSource || dataSource.length === 0) {
      return;
    }

    let tempDataSource = JSON.parse(JSON.stringify(dataSource));

    let data1 = tempDataSource[0];
    let data2 = tempDataSource[1];
    let tableData = [];
    for (let i = 0; i < data1.length; i++) {
      let obj = Object.assign(data1[i], data2[i]);
      tableData.push(obj);
    }

    let totalQtymate = 0;
    let totalRebreed = 0;
    let totalAbortion = 0;
    let totalEmpty = 0;
    let totalDead = 0;
    let totalCull = 0;

    tableData.map((obj) => {
      totalQtymate += obj.qtymate;
      totalRebreed += obj.rebreed;
      totalAbortion += obj.abortion;
      totalEmpty += obj.empty;
      totalDead += obj.dead;
      totalCull += obj.cull;
    });

    let standard =
      ((totalQtymate - (totalRebreed + totalAbortion + totalEmpty + totalDead + totalCull)) / totalQtymate) * 100;
    standard = Math.round(standard * 100) / 100;

    let actual =
      ((totalQtymate - (totalRebreed + totalAbortion + totalEmpty + totalDead + totalCull)) / totalQtymate) * 100;
    actual = Math.round(actual * 100) / 100;

    let totalData = {
      abortion: totalAbortion,
      cull: totalCull,
      dead: totalDead,
      empty: totalEmpty,
      farrowingFcstRate: standard ? standard : 0,
      farrowingRate: actual ? actual : 0,
      qtymate: totalQtymate,
      rebreed: totalRebreed,
      mateGroup: '合计'
    };
    tableData.push(totalData);
    this.setState({ tableData: tableData });
  }

  // 获取损失母猪周次分布
  getLossWeekSpreadData = (startWeek, endWeek) => {
    axios
      .post(
        `${ROOT_PATH}/api/forward/ifarm/lossSowBirthWeekSpread`,
        qs.stringify({
          mateGroupStart: startWeek,
          mateGroupEnd: endWeek,
          gd_type: 'D001301',
          gd_code: '2003'
        }),
        {
          headers: {
            'x-http-appid': '1',
            'x-http-device': '0',
            'Content-Type': 'application/x-www-form-urlencoded',
            Authorization: TOKEN,
            farmorg: FARM_ORG,
            orgcode: ORG_CODE
          }
        }
      )
      .then((res) => {
        this.parseLossWeekData(res.data);
      })
      .catch((err) => {
        this.setState({ hasLossData: false });
        return err;
      });
  };

  // 绘制报表-- 19周分娩率
  parseFarrow19WkData(data) {
    if (!data || data.length === 0) {
      this.setState({ hasFarrowData: false });
      return;
    }
    this.setState({ hasFarrowData: true });

    this.drawReport(data);
  }

  drawReport = (results) => {
    let names = {
      rebreed: '返情', //返情
      abortion: '流产', //流产
      empty: '空怀', //空怀
      dead: '死亡', //死亡
      cull: '淘汰', //淘汰
      qtymate: '配种数' //配种数
    };

    let data = [];
    let times = [];
    results[0].map((obj) => {
      if (times.indexOf(obj.mateGroup) == -1) {
        times.push(obj.mateGroup);
      }
    });

    let attrNames = Object.keys(names);
    /***********************************************************************
     * 由于antv F2 cat类型在部分显示的数据，部分安卓机型，会出现line图，线会出现连接错乱错误
     * 紧致对应方案，强制将X轴的类型改为timeCat，后期需要通过antv源码去排查错误，将X轴标识更正
     * 为使用time字段，cat类型
     ***********************************************************************/
    const date = new Date();
    const tempMap = {};
    times.map((time, i) => {
      date.setDate(date.getDate() + 1);
      let strDate = df(date, 'yyyy-mm-dd');
      tempMap[strDate] = time;
      attrNames.map((name, j) => {
        let obj = {};
        obj['strDate'] = strDate;
        obj['time'] = time;
        obj['groupName'] = names[name];
        obj['count'] = results[1][i][name];
        if (j == 0) {
          obj['type'] = '预计分娩率';
          obj['value'] = results[0][i]['farrowingFcstRate'];
        } else if (j == 1) {
          obj['type'] = '实际分娩率';
          obj['value'] = results[0][i]['farrowingRate'];
        }
        data.push(obj);
      });
    });

    let chart = this.farrowChart;
    if (chart) {
      chart.clear();
    } else {
      chart = new F2.Chart({
        id: 'mountNode1',
        pixelRatio: window.devicePixelRatio,
        padding: [110, 50, 40, 40],
        plugins: [require('@antv/f2/lib/plugin/scroll-bar'), require('@antv/f2/lib/interaction/pan')]
      });
    }

    this.farrowChart = chart;

    let originlDate = [];
    let counts = [];

    data.map((obj) => {
      if (originlDate.length < 7) {
        if (!originlDate.includes(obj.strDate)) {
          originlDate.push(obj.strDate);
        }
      }
      if (obj.count !== undefined) {
        counts.push(obj.count);
      }
    });

    let countMax = Math.max.apply(null, counts);

    let countObj = { alias: '头数' };
    if (!countMax) {
      countObj['ticks'] = [0, 5, 10, 15, 20];
    } else {
      countObj['max'] = countMax;
      countObj['min'] = 0;
      countObj['tickCount'] = 5;
    }
    chart.source(data, {
      value: {
        ticks: [0, 25, 50, 75, 100],
        tickCount: 5,
        formatter: function(val) {
          return val + '%';
        }
      },
      strDate: {
        type: 'timeCat',
        values: originlDate,
        formatter: function(val) {
          let key = df(new Date(val), 'yyyy-mm-dd');
          return tempMap[key];
        }
      },
      count: countObj
    });

    // 设置坐标轴
    chart.axis('count', {
      // 头数
      position: 'left',
      line: null,
      grid: F2.Global._defaultAxis.grid
    });
    // chart.axis('strDate', {
    // label: function(value) {
    //   console.log(tempMap[value])
    //   return tempMap[value]
    // }
    // })
    chart.axis('value', {
      position: 'right',
      grid: null
    });

    // // 设置图例
    var legendItems = [
      {
        name: '返情',
        marker: { symbol: 'circle', radius: 5, fill: stateToColor['返情'] },
        fill: stateToColor['返情'],
        checked: true
      },
      {
        name: '流产',
        marker: { symbol: 'circle', radius: 5, fill: stateToColor['流产'] },
        checked: true
      },
      {
        name: '空怀',
        marker: { symbol: 'circle', radius: 5, fill: stateToColor['空怀'] },
        checked: true
      },
      {
        name: '死亡',
        marker: { symbol: 'circle', radius: 5, fill: stateToColor['死亡'] },
        checked: true
      },
      {
        name: '淘汰',
        marker: { symbol: 'circle', radius: 5, fill: stateToColor['淘汰'] },
        checked: true
      },
      {
        name: '配种数',
        marker: { symbol: 'circle', radius: 5, fill: stateToColor['配种数'] },
        checked: true
      },
      {
        name: '实际分娩率',
        fill: '#FE5578',
        checked: true,
        marker: function mark(x, y, r, ctx) {
          ctx.lineWidth = 1;
          ctx.strokeStyle = ctx.fillStyle;
          ctx.moveTo(x - 3 - r - 5, y);
          ctx.lineTo(x - 3 + r + 5, y);
          ctx.stroke();
          ctx.arc(x - 3, y, 5, 0, Math.PI * 2, false);
          ctx.fill();
        }
      },
      {
        name: '预计分娩率',
        fill: '#27D3A6',
        checked: true,
        marker: function mark(x, y, r, ctx) {
          ctx.lineWidth = 1;
          ctx.strokeStyle = ctx.fillStyle;
          ctx.moveTo(x - 3 - r - 5, y);
          ctx.lineTo(x - 3 + r + 5, y);
          ctx.stroke();
          ctx.arc(x - 3, y, 5, 0, Math.PI * 2, false);
          ctx.fill();
        }
      }
    ];

    chart.legend({
      align: 'center',
      itemWidth: 40,
      itemGap: 44,
      titleStyle: {
        fill: '#666',
        fontSize: 14
      },
      custom: true,
      items: legendItems
    });

    // 设置tooltip
    chart.tooltip({
      showCrosshairs: false,
      showItemMarker: true,
      showTitle: true,
      background: {
        radius: 6,
        padding: [6, 10]
      },
      onShow: (ev) => {
        ev.tooltipMarkerCfg.type = 'rect';
        var items = ev.items;
        items.map((item) => {
          if (item.name.indexOf('分娩率') === -1) {
            item.value = item.value + '头';
          }
        });
      }
    });

    // 设置辅助文本
    chart.guide().text({
      position: ['0%', '0%'],
      content: '头数（头）',
      style: {
        textAlign: 'center',
        fontSize: 9,
        fill: '#666'
      },
      offsetY: -20
    });

    chart.guide().text({
      position: ['100%', '0%'],
      content: '分娩率（%）',
      style: {
        textAlign: 'left',
        fontSize: 9,
        fill: '#666'
      },
      offsetY: -20
    });

    chart.guide().line({
      limitInPlot: true
    });

    // 定义进度条
    chart.scrollBar({
      mode: 'x',
      xStyle: {
        offsetY: -10
      }
    });

    chart
      .interval()
      .position('strDate*count')
      .color('groupName', function(item) {
        let color = stateToColor[item];
        return color ? color : '#FF3B30';
      })
      .adjust('stack')
      .size(20);

    chart
      .line()
      .position('strDate*value')
      .shape('smooth')
      .color('type', function(type) {
        if (type === '实际分娩率') {
          return '#FE5578';
        } else if (type === '预计分娩率') {
          return '#27D3A6';
        }
      });

    chart
      .point()
      .position('strDate*value')
      .shape('smooth')
      .color('type', function(type) {
        if (type === '实际分娩率') {
          return '#FE5578';
        } else if (type === '预计分娩率') {
          return '#27D3A6';
        }
      })
      .style({
        fill: '#fff',
        lineWidth: 1
      });

    chart.render();
    chart.interaction('pan', {
      speed: 1
    });
  };

  // 绘制报表 -- 损失母猪周次分布
  parseLossWeekData(data) {
    if (!data || data.length === 0) {
      this.setState({ hasLossData: false });
      return;
    }
    this.setState({ hasLossData: true });

    this.drawLossWeekSpreadReport(data);
  }

  drawLossWeekSpreadReport(data) {
    let type = {
      '1': '流产',
      '2': '空怀',
      '3': '返情',
      D: '死亡',
      C: '淘汰'
    };
    let days = {
      lass18: '<18天',
      btw19to24: '19-24天',
      btw25to30: '25-30天',
      btw31to38: '31-38天',
      btw39to44: '39-44天',
      btw45to79: '45-79天',
      more80: '>80天'
    };

    let newData = [];
    Object.keys(days).map((attr) => {
      let obj = {};
      data.map((item) => {
        obj = {
          days: days[attr],
          weeks: item[attr],
          groupName: type[item.gtype]
        };
        newData.push(obj);
      });
    });

    let chart = this.lossChart;
    if (chart) {
      chart.clear();
    } else {
      chart = new F2.Chart({
        id: 'mountNode2',
        pixelRatio: window.devicePixelRatio, // 指定分辨率
        padding: [80, 'auto', 'auto', 'auto']
      });
    }

    this.lossChart = chart;

    let weeks = [];
    newData.map((obj) => {
      if (obj.weeks !== undefined) {
        weeks.push(obj.weeks);
      }
    });
    let max = Math.max.apply(null, weeks);

    let weekObj = { alias: '周次' };
    if (!max) {
      weekObj['ticks'] = [0, 1, 2, 3, 4, 5];
    }

    const defs = {
      weeks: weekObj
    };

    chart.source(newData, defs);

    // 设置tooltip
    chart.tooltip({
      showCrosshairs: false,
      showItemMarker: true,
      showTitle: true,
      background: {
        radius: 6,
        padding: [6, 10]
      },
      onShow: function onShow(ev) {
        var items = ev.items;
        items.map((item) => {
          item.value = item.value + '头';
        });
      }
    });

    // 设置图例
    chart.legend({
      position: 'top',
      align: 'center',
      itemWidth: 50,
      marker: {
        radius: 5
      },
      titleStyle: {
        fill: '#666',
        fontSize: 14
      }
    });

    // 设置辅助文本
    chart.guide().text({
      position: ['0%', '0%'],
      content: '母猪(头)',
      style: {
        textAlign: 'center',
        fontSize: 9,
        fill: '#666'
      },
      offsetY: -20
    });

    chart
      .interval()
      .position('days*weeks')
      .color('groupName', function(item) {
        if (item === '返情') return '#1890FF';
        if (item === '淘汰') return '#FE5578';
        if (item === '流产') return '#FFD400';
        let color = stateToColor[item];
        return color ? color : '#FF3B30';
      })
      .adjust('stack');

    chart.render();
    chart.pluginGesture({
      gesture: {
        tap: (data, ev) => {
          let day = {
            '<18天': [0, 18],
            '19-24天': [19, 24],
            '25-30天': [25, 30],
            '31-38天': [31, 38],
            '39-44天': [39, 44],
            '45-79天': [45, 79],
            '>80天': [80, 9999]
          };
          const point = Util.getRelativePosition(ev.center, chart.get('canvas'));
          let plot = chart.get('plotRange');
          const { x, y } = point;
          const { tl, tr, br } = plot;
          if (x >= tl.x && x <= tr.x && y >= tl.y && y <= br.y) {
            let attr = data[0]._origin.days;
            let selected = day[attr];
            let farrowData = {
              mateGroupStart: this.state.startWeek,
              mateGroupEnd: this.state.endWeek,
              startDay: selected[0],
              endDay: selected[1]
            };
            console.log(farrowData);
            this.setState({
              modalShow: true,
              modalContent: <Farrow19WkDetail2 data={farrowData} />
            });
          }
        }
      }
    });
  }

  doSearch = (startWeek, endWeek) => {
    alreay = 0;
    Toast.loading('加载中...', 0);

    this.getFarrow19WeekData(startWeek, endWeek);
    this.getLossWeekSpreadData(startWeek, endWeek);
  };

  componentDidMount() {
    window._czc.push(['_trackEvent', '进入19周分娩率页面']);
    this.doSearch(this.state.startWeek, this.state.endWeek);
  }

  componentDidUpdate() {
    if (alreay === 1) {
      Toast.hide();
    }
  }

  componentWillUnmount() {
    this.setState = () => {};
  }

  render() {
    return (
      <React.Fragment>
        <List.Item
          arrow="horizontal"
          className="span-4"
          extra={`${this.state.startWeek} 至 ${this.state.endWeek}`}
          onClick={() => {
            this.setState({ visible: true });
          }}
        >
          选择日期
        </List.Item>
        <DatePicker
          defaultValues={[this.state.startDate, this.state.endDate]}
          mode={'week'}
          onCancel={() => {
            this.setState({ visible: false });
          }}
          onConfirm={(start, end, type) => {
            let startDate = type === 'week' ? start.startDate : start;
            let endDate = type === 'week' ? end.endDate : end;
            let startWeek = dateToWeek(startDate);
            let endWeek = dateToWeek(endDate);

            this.setState({
              visible: false,
              startDate,
              endDate,
              startWeek,
              endWeek
            });
            this.doSearch(startWeek, endWeek);
          }}
          visible={this.state.visible}
        />
        <List renderHeader={() => ''}>
          <span className="title">19周分娩率</span>
          {this.state.hasFarrowData ? (
            <canvas id="mountNode1" height={330} width={clientWidth} />
          ) : (
            <EmptyReport height={330} width={clientWidth} />
          )}
          <Table columns={this.state.columns} data={this.state.tableData} />
        </List>
        <List renderHeader={() => ''}>
          <span className="title">损失母猪时段分布</span>
          {this.state.hasLossData ? (
            <canvas id="mountNode2" height={300} width={clientWidth} />
          ) : (
            <EmptyReport height={300} width={clientWidth} />
          )}
        </List>
        <WhiteSpace size="xl" />
        {/*弹出层公用模态框、*/}
        <Modal
          animationType="slide-up"
          maskClosable={false}
          closable
          onClose={() => {
            this.setState({
              modalShow: false
            });
          }}
          popup
          visible={this.state.modalShow}
        >
          {this.state.modalContent}
        </Modal>
      </React.Fragment>
    );
  }
}

export default Farrow19WK;
